import React, { Component } from 'react';

class About extends Component {
   render() {

      if (this.props.data) {
         var name = this.props.data.name;
         var profilepic = "images/" + this.props.data.image;
         var bio = this.props.data.bio;
         var fullname = this.props.data.fullname;
         var street = this.props.data.address.street;
         var city = this.props.data.address.city;
         var state = this.props.data.address.state;
         var zip = this.props.data.address.zip;
         var phone = this.props.data.phone;
         var email = this.props.data.email;
         var resumeDownload = this.props.data.resumedownload;
      }

      return (
         <section id="about">
            <div className="row">
               <div className="three columns">
                  <img className="profile-pic" src={profilepic} alt="Tim Baker Profile Pic" />
                  <p >{fullname} <br></br> {city}</p>

               </div>
               <div className="nine columns main-col">
                  <h2>About Me</h2>

                  <p>{bio}</p>
                  <h2>Contact</h2>
                  <ul key="LinkedIn"><a href="https://www.linkedin.com/in/pxong/"><i className="fa fa-linkedin-square"></i> LinkedIn</a></ul>

                  <div className="row">

                     <div className="columns download">
                        {/* <p>
                           <a href={resumeDownload} className="button"><i className="fa fa-download"></i>Download Resume</a>
                        </p> */}
                     </div>
                  </div>
               </div>
            </div>

         </section >
      );
   }
}

export default About;
